import { List, Box, ListSubheader } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
// @mui

//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const currentUser = JSON.parse(localStorage.getItem('currentuser'));
  console.log(currentUser, 'currentUser');
  let itemsToRender;

  if (currentUser?.role === 'admin') {
    itemsToRender = navConfig[0]?.items;
  }

  return (
    <Box {...other}>
      {itemsToRender?.map((item) => {
        return (
          <List key={item.path} disablePadding sx={{ px: 2 }}>
            <NavListRoot key={item.title} list={item} isCollapse={isCollapse} />
          </List>
        );
      })}
      <div className="h-[200px]"></div>
    </Box>
  );
}
